import { useState } from 'react'
import {
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from '@mui/material'
import useCoupons from '../../hooks/useCoupons'
import { Coupon } from '../../services/coupons-service'

const NewCoupon = () => {
  const [selected, setSelected] = useState<string>('')
  const [coupon, setCoupon] = useState<Coupon>()
  const { availableAmounts, createCoupon } = useCoupons()

  const submit = async () => {
    if (!selected) return
    const createdCoupon = await createCoupon(Number(selected))
    setCoupon(createdCoupon)
  }

  return (
    <Container sx={{ display: 'flex' }}>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minWidth: '50%'
        }}>
        <FormControl sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="demo-simple-select-helper-label">Creditos</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            value={selected}
            label="Creditos"
            onChange={(e) => setSelected(e.target.value)}>
            {Object.keys(availableAmounts).map((amount) => (
              <MenuItem key={amount} value={amount}>
                {amount}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          disabled={selected ? false : true}
          sx={{ width: '80%' }}
          onClick={submit}>
          Crear Cupón
        </Button>
      </Container>

      <Container sx={{ minWidth: '50%' }}>
        {coupon && (
          <>
            <Typography mt={1}>
              Código: <strong>{coupon.code}</strong>
            </Typography>
            <Typography mt={2}>Id: {coupon.id}</Typography>
            <Typography mt={2}>Creditos: {coupon.amount}</Typography>
          </>
        )}
      </Container>
    </Container>
  )
}

export default NewCoupon
